<div class="full-screen-container" data-cy="auth-referrer-login">
  <div style="font-size: 10px; position: absolute; bottom: 0; right: 0; color: var(--tdo-primary); margin-right: 4px;" data-cy="auth-referrer-login-version">
    {{appName}} v{{appVersion}}
  </div>
  <div class="main-flex-container" data-cy="auth-referrer-login-container">
    <div class="card-container" data-cy="auth-referrer-login-card-container">
      <mat-card appearance="outlined" class="login-card" data-cy="auth-referrer-login-card">
        <div mat-card-image class="login-card-header" data-cy="auth-referrer-login-header">
          <div class="login-card-header-text" data-cy="auth-referrer-login-title">Referrer Login</div>
          <img class="login-card-img" src="" data-cy="auth-referrer-login-img" />
        </div>

        <div class="login-card-content" data-cy="auth-referrer-login-content">
          <div class="inline-form" data-cy="auth-referrer-login-username-form">
            <mat-label class="form-label" data-cy="auth-referrer-login-username-label">Username</mat-label>
            <mat-form-field class="w-100" data-cy="auth-referrer-login-username-field">
              <input matInput type="text" name="username" autocomplete="username" data-cy="auth-referrer-login-username-input"
                     maxlength="25" id="username" [(ngModel)]="username" value="{{username}}"
                     (keyup.enter)="btntoken_click()" [formControl]="frmCtrl"
                     required />              
            </mat-form-field>
          </div>

          <div class="inline-form" data-cy="auth-referrer-login-password-form">
            <mat-label class="form-label" data-cy="auth-referrer-login-password-label">Password</mat-label>
            <mat-form-field class="w-100" data-cy="auth-referrer-login-password-field">
              <input matInput data-cy="auth-referrer-login-password-input"
                     type="password"
                     name="password"
                     maxlength="25"
                     id="pass"
                     [(ngModel)]="pass"
                     value="{{pass}}"
                     (keyup.enter)="btntoken_click()"
                     [formControl]="frmCtrl"
                     required />
            </mat-form-field>            
          </div>
        </div>
        <div *ngIf="invalidCredentials" data-cy="auth-referrer-login-error-message" ngClass="loginError">Please provide valid credentials.</div>
        <mat-card-footer class="login-card-footer" data-cy="auth-referrer-login-footer">
          <div class="forget-pw-text" style="cursor: pointer;" (click)="forgotPasswordClicked()" data-cy="auth-referrer-login-forgot-password">Forgot password</div>
          <button mat-button class="login-card-btn" (click)="btntoken_click()" type="submit" color="primary" [disabled]="isLoading || loadingLocations || !selectedLocation" data-cy="auth-referrer-login-submit-btn">
            <span *ngIf="!isLoading" data-cy="auth-referrer-login-submit-text">Login</span>
            <mat-spinner class="login-spinner" *ngIf="isLoading" [diameter]="20" data-cy="auth-referrer-login-spinner"></mat-spinner>
          </button>

        </mat-card-footer>
      </mat-card>

      <div class="links-search-container" data-cy="auth-referrer-login-links-container">
        <a mat-button class="links" (click)="contactUsBtnClicked()" data-cy="auth-referrer-login-contact-link">
          <mat-icon class="material-icons-outlined link-icons" data-cy="auth-referrer-login-contact-icon">phone</mat-icon>Contact Us
        </a>
      </div>
    </div>
  </div>
</div>
